import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import Popup from "../../../../components/Popup";
import "./styles.css";

const { confirm } = Modal;

export default function CategorySectionPopup({
  loading = false,
  visible = false,
  title = "",
  data = {},
  saveHandler,
  cancelHandler,
}) {
  // Initial form state based on data
  const [formValues, setFormValues] = useState({
    name: data.name || "",
    description: data.description || "",
    priority: data.priority || "",
  });

  // Form validation state
  const [formErrors, setFormErrors] = useState({});

  // Update form when data changes
  useEffect(() => {
    if (data) {
      setFormValues({
        name: data.name || "",
        description: data.description || "",
        priority: data.priority || "",
      });
    }
  }, [data]);

  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  // Validate form
  const validateForm = () => {
    const errors = {};

    if (!formValues.name) {
      errors.name = "Please enter the name of category section";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Handle form submission with confirmation modal for edit
  const handleSubmit = () => {
    if (validateForm()) {
      // If editing existing category section, show confirmation modal
      if (data.category_section_id) {
        confirm({
          title: 'Confirm Edit',
          icon: <ExclamationCircleOutlined />,
          content: 'Are you sure you want to update this category section?',
          okText: 'Yes, Update',
          cancelText: 'Cancel',
          onOk() {
            saveHandler(formValues);
          },
        });
      } else {
        // For new category section, save directly
        saveHandler(formValues);
      }
    }
  };

  return (
    <Popup
      title={title}
      visible={visible}
      loading={loading}
      cancelHandler={() => cancelHandler()}
      saveHandler={handleSubmit}
    >
      <form className="category-form">
        {/* Name Field - Full Width */}
        <div className="form-group full-width">
          <label htmlFor="name">
            Name <span className="required">*</span>
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={formValues.name}
            onChange={handleInputChange}
            placeholder="Ex. Grocery & Kitchen"
            className={formErrors.name ? "input-error" : ""}
          />
          {formErrors.name && (
            <div className="error-message">{formErrors.name}</div>
          )}
        </div>

        {/* Description Field */}
        <div className="form-group full-width">
          <label htmlFor="description">Description</label>
          <textarea
            id="description"
            name="description"
            value={formValues.description}
            onChange={handleInputChange}
            placeholder="Ex. Essential groceries and kitchen items"
            maxLength={255}
            rows={3}
          />
          <div className="char-count">{formValues.description.length}/255</div>
        </div>

        {/* Priority Field */}
        <div className="form-group">
          <label htmlFor="priority">Priority</label>
          <input
            type="number"
            id="priority"
            name="priority"
            value={formValues.priority}
            onChange={handleInputChange}
            placeholder="Ex. 1, 2, 3..."
            min={0}
          />
          <div className="help-text">Lower numbers appear first. Leave empty for no specific priority.</div>
        </div>
      </form>
    </Popup>
  );
}
